import React from 'react';
import { SparklesIcon } from 'lucide-react';
export function Navbar() {
  return <nav className="sticky top-0 z-50 bg-white/80 backdrop-blur-md shadow-sm" data-id="element-116">
      <div className="container mx-auto px-4 py-3 flex justify-between items-center" data-id="element-117">
        <div className="flex items-center" data-id="element-118">
          <SparklesIcon className="h-6 w-6 text-pink-500 mr-2" data-id="element-119" />
          <span className="text-xl font-bold bg-gradient-to-r from-pink-500 to-purple-600 bg-clip-text text-transparent" data-id="element-120">
            Nail Masterclass Pro
          </span>
        </div>
        <a href="https://nailmasterclasspro.mitiendanube.com/checkout/v3/start/1789839156/b96e63bc245079acd7af9657978acace71d015a6?from_store=1&country=AR" className="bg-gradient-to-r from-pink-500 to-purple-600 text-white px-4 py-2 rounded-full text-sm font-medium shadow-md hover:shadow-lg transition-all" data-id="element-121">
          ¡Inscríbete Ahora! - $14.999
        </a>
      </div>
    </nav>;
}